import React, {useState, useEffect} from "react";
import {TextField, DialogContent, DialogActions} from "@material-ui/core";
import {Button, Grid, FormControlLabel, Checkbox} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import axios from "axios";
import {Close, Save} from "@material-ui/icons";
import {getCookie} from "../../../components/auth/Helpers";
import "react-dropzone-uploader/dist/styles.css";

const FilterComponent = (props) => {
  const token = getCookie("token");
  const [clientsList, setClientsList] = useState([]);
  const [fridgesTypesList, setFridgesTypesList] = useState([]);
  const [operationsList, setOperationsList] = useState([]);
  const [statusList, setStatusList] = useState([
    "In Progress",
    "Completed",
    "Failed",
    "On Hold",
    "Assigned",
    "Unassigned",
    "Accepted",
    "Canceled",
    "Return To Origin",
  ]);

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/operations`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setClientsList(response[0].data);
          setFridgesTypesList(response[1].data);
          setOperationsList([...response[2].data, {name: "Swap"}]);
        });
    };
    fetchData();
  }, []);

  const handleChangeAutoComplete = (e, newValue, name) => {
    props.setFilterFormValues({...props.filterFormValues, [name]: newValue});
  };

  const handleSearchDate = (e) => {
    const {name, value} = e.target;
    props.setFilterFormValues({...props.filterFormValues, [name]: value});
  };
  const handleChangeCheckbox = (e) => {
    const {name, checked} = e.target;
    props.setFilterFormValues({...props.filterFormValues, [name]: checked});
  };

  const getCounts = (filterArray) => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/liveOperations/count?${filterArray.join("&")}`, {
        headers: {Authorization: `Bearer ${token}`},
      })
      .then((response) => {
        props.setCountLiveOperations(response.data);
      })
      .catch((err) => {});
  };

  const handleOnSubmit = async () => {
    props.setIsLoading(true);
    let filterArray = [];
    if (props.filterFormValues.client._id) filterArray.push(`clientId=${props.filterFormValues.client._id}`);
    if (props.filterFormValues.fridgesType._id)
      filterArray.push(`fridgeTypeId=${props.filterFormValues.fridgesType._id}`);
    if (props.filterFormValues.operationType && props.filterFormValues.operationType.name)
      filterArray.push(`operationType=${props.filterFormValues.operationType.name}`);
    if (props.filterFormValues.status) filterArray.push(`status=${props.filterFormValues.status}`);
    if (props.filterFormValues.fromDate) filterArray.push(`fromDate=${props.filterFormValues.fromDate}`);
    if (props.filterFormValues.toDate) filterArray.push(`toDate=${props.filterFormValues.toDate}`);
    if (props.filterFormValues.preventive) filterArray.push(`exceededPreventive=true`);
    if (props.filterFormValues.condition)
      filterArray.push(`condition=${props.filterFormValues.condition.id}`);
    if (props.filterFormValues.location) filterArray.push(`location=${props.filterFormValues.location.id}`);

    if (props.filterFormValues.store) filterArray.push(`location_id=${props.filterFormValues.store._id}`);
    if (props.filterFormValues.warehouse)
      filterArray.push(`location_id=${props.filterFormValues.warehouse._id}`);

    if (props.filterFormValues.ship_from)
      filterArray.push(`ship_from=${props.filterFormValues.ship_from.id}`);
    if (props.filterFormValues.ship_from_store)
      filterArray.push(`ship_from_id=${props.filterFormValues.ship_from_store._id}`);
    if (props.filterFormValues.ship_from_warehouse)
      filterArray.push(`ship_from_id=${props.filterFormValues.ship_from_warehouse._id}`);

    if (props.filterFormValues.ship_to) filterArray.push(`ship_to=${props.filterFormValues.ship_to.id}`);
    if (props.filterFormValues.ship_to_store)
      filterArray.push(`ship_to_id=${props.filterFormValues.ship_to_store._id}`);
    if (props.filterFormValues.ship_to_warehouse)
      filterArray.push(`ship_to_id=${props.filterFormValues.ship_to_warehouse._id}`);

    await axios(
      `${process.env.REACT_APP_BASE_URL}/liveOperations?limit=${props.pagingInfo.limit}&skip=0&searchEntry=${
        props.searchEntry || ""
      }&${filterArray.join("&")}`,
      {
        responseType: "json",
        headers: {Authorization: `Bearer ${token}`},
      }
    )
      .then(function (response) {
        // getCounts(filterArray);
        props.setTabIndex(0);
        props.setCountLiveOperations({total: response.data.count, data: response.data.tabs});
        // Reset to page 0 so the paging state stays in sync with the freshly filtered result set -
        // otherwise a later page change reuses the old skip and can land past the end of the new results.
        props.setPagingInfo({...props.pagingInfo, page: 0, skip: 0, count: response.data.count});
        props.setItems(response.data.data);
        props.setItemsFiltered(response.data.data);
        props.setOpenDialog(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        props.setIsLoading(false);
      });
  };
  return (
    <>
      <DialogContent dividers>
        <h3>Operations Report Filter</h3>
      </DialogContent>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="ClientInput"
              options={clientsList || {}}
              value={props.filterFormValues.client || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "client")}
              renderInput={(params) => <TextField {...params} label="Client" name="client" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="fridgesTypeInput"
              options={fridgesTypesList || {}}
              value={props.filterFormValues.fridgesType || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "fridgesType")}
              renderInput={(params) => <TextField {...params} label="Fridges Type" />}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="operationsTypeInput"
              options={operationsList || {}}
              value={props.filterFormValues.operationType || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "operationType")}
              renderInput={(params) => <TextField {...params} label="Operations Type" />}
            />
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <Autocomplete
              id="statusInput"
              options={statusList}
              value={props.filterFormValues.status || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "status")}
              renderInput={(params) => <TextField {...params} label="Status" />}
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              id="fromDate"
              name="fromDate"
              label="From Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="toDate"
              name="toDate"
              label="To Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={handleSearchDate}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="location"
              options={[
                {id: "store", name: "Store"},

                {id: "warehouse", name: "Warehouse"},
              ]}
              value={props.filterFormValues.location || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "location")}
              renderInput={(params) => <TextField {...params} label="Location" name="location" />}
            />
          </Grid>

          {props.filterFormValues.location && props.filterFormValues.location.id == "store" && (
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="store"
                options={props.storesList}
                value={props.filterFormValues.store || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "store")}
                renderInput={(params) => <TextField {...params} label="Store" name="store" />}
              />
            </Grid>
          )}

          {props.filterFormValues.location && props.filterFormValues.location.id == "warehouse" && (
            <Grid item xs={12} sm={4}>
              <Autocomplete
                id="warehouse"
                options={props.warehousesList}
                value={props.filterFormValues.warehouse || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "warehouse")}
                renderInput={(params) => <TextField {...params} label="Site" name="warehouse" />}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={4}>
            <Autocomplete
              id="condition"
              options={[
                {id: "New", name: "New"},

                {id: "Used", name: "Used"},
              ]}
              value={props.filterFormValues.condition || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "condition")}
              renderInput={(params) => <TextField {...params} label="condition" name="condition" />}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="ship_from"
              options={[
                {id: "store", name: "Store"},

                {id: "warehouse", name: "Warehouse"},
              ]}
              value={props.filterFormValues.ship_from || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "ship_from")}
              renderInput={(params) => <TextField {...params} label="From" name="ship_from" />}
            />
          </Grid>

          {props.filterFormValues.ship_from && props.filterFormValues.ship_from.id == "store" && (
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="ship_from_store"
                options={props.storesList}
                value={props.filterFormValues.ship_from_store || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "ship_from_store")}
                renderInput={(params) => <TextField {...params} label="Store" name="ship_from_store" />}
              />
            </Grid>
          )}

          {props.filterFormValues.ship_from && props.filterFormValues.ship_from.id == "warehouse" && (
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="ship_from_warehouse"
                options={props.warehousesList}
                value={props.filterFormValues.ship_from_warehouse || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "ship_from_warehouse")}
                renderInput={(params) => <TextField {...params} label="Site" name="ship_from_warehouse" />}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <Autocomplete
              id="ship_to"
              options={[
                {id: "store", name: "Store"},

                {id: "warehouse", name: "Warehouse"},
              ]}
              value={props.filterFormValues.ship_to || {}}
              getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "ship_to")}
              renderInput={(params) => <TextField {...params} label="To" name="ship_to" />}
            />
          </Grid>

          {props.filterFormValues.ship_to && props.filterFormValues.ship_to.id == "store" && (
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="ship_to_store"
                options={props.storesList}
                value={props.filterFormValues.ship_to_store || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "ship_to_store")}
                renderInput={(params) => <TextField {...params} label="Store" name="ship_to_store" />}
              />
            </Grid>
          )}

          {props.filterFormValues.ship_to && props.filterFormValues.ship_to.id == "warehouse" && (
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id="ship_to_warehouse"
                options={props.warehousesList}
                value={props.filterFormValues.ship_to_warehouse || {}}
                getOptionLabel={(option) => (Object.keys(option).length !== 0 ? option.name : "")}
                fullWidth
                onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "ship_to_warehouse")}
                renderInput={(params) => <TextField {...params} label="Site" name="ship_to_warehouse" />}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.filterFormValues.preventive}
                  onChange={handleChangeCheckbox}
                  name="preventive"
                />
              }
              label="Exceeded preventive Day"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={() => props.setOpenDialog(false)}
          startIcon={<Close />}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          className="btn btn--save"
          onClick={handleOnSubmit}
          startIcon={<Save />}
        >
          Save
        </Button>
      </DialogActions>
    </>
  );
};

export default FilterComponent;
